module.exports = __webpack_public_path__ + "static/day18-7f6367b857e0ef198819d90e8544e795.png";